import { cloneDeep } from 'lodash';
import { POE_KEYS } from '../../../routes/contractsView/components/Step1ContractSavings/constants/poeKeys';
import { offersAccountsAdapter } from './singleAccountAdapter';

const reduceInitialState = {};
const DOUBLE_RATE_INCREMENT = 2;
const SIMPLE_RATE_INCREMENT = 1;
const BUNDLE_TAGS = [1, 3];

const isBundleWithTag = (bundle) => BUNDLE_TAGS.includes(bundle);
const isTypeWithTerm = (type) => type.includes('WITH_TERM');
const isTypeWithCondition = (type) => type.includes('WITH_CONDITION');

const processOffer = (offer, superIndex) => {
    const { metadata, flowId, productId, offersValues } = offer;
    const { accountConfig, context, accountTexts } = metadata;

    const accountRate = {
        simpleRate: {
            tae: `${accountConfig.tae} %`,
            tin: `${accountConfig.tin} %`,
            superIndex: superIndex
        }
    };
    if (isTypeWithCondition(flowId)) {
        accountRate.doubleRate = {
            tae: `${accountConfig.taeBonified} %`,
            tin: `${accountConfig.tinBonified} %`,
            superIndex: superIndex + SIMPLE_RATE_INCREMENT
        };
    }
    const objectifiedOffer = {
        accountConfig,
        accountDefinition: { context: context},
        accountTexts: accountTexts
    };
    const result = offersAccountsAdapter(objectifiedOffer);

    return {
        accountName: `${context}-${accountConfig.name}`,
        productId: productId,
        accountTerm: isTypeWithTerm(flowId) ? offersValues.months : null,
        accountRate: accountRate,
        accountTag: isBundleWithTag(metadata.ccBundle) ? {
            tag: metadata.ccBundle,
            text: `${context}-${metadata.ccBundleLabel}`
        } : null,
        accountTexts: result,
        accountConfig,
        flowId
    }
}

const produceExamples = (offer, superIndex) => {
    const flowId = offer.flowId;
    if (isTypeWithCondition(flowId)) {
        return [
            {
                example: POE_KEYS[flowId].examples[0],
                superIndex: superIndex,
                accountConfig: offer.metadata.accountConfig
            },
            {
                example: POE_KEYS[flowId].examples[1],
                superIndex: superIndex + SIMPLE_RATE_INCREMENT,
                accountConfig: offer.metadata.accountConfig
            }
        ]
    } else {
        return [
            {
                example: POE_KEYS[flowId].examples[0],
                superIndex: superIndex,
                accountConfig: offer.metadata.accountConfig
            }
        ]
    }
}

export const savingsAccountsLandingAdapter = ({ offers }) => {
    let superIndex = 1;
    const processedOffers = offers.getIn(['data', 'offers']).toJS().reduce((acc, offer) => {
        const flowId = offer.flowId;
        const processedOffer = processOffer(offer, superIndex);
        const producedExamples = produceExamples(offer, superIndex);
        
        if (acc.offers[flowId]) {
            acc.offers[flowId].push(processedOffer);
        } else {
            acc.offers[flowId] = [processedOffer];
            acc.order.push(flowId);
        }

        acc.examples = acc.examples.concat(producedExamples);

        if (isTypeWithCondition(flowId)) {
            superIndex += DOUBLE_RATE_INCREMENT;
        } else {
            superIndex += SIMPLE_RATE_INCREMENT;
        }
        return acc;
    }, { offers: cloneDeep(reduceInitialState), examples: [], order: [] });
    return {
        offers: processedOffers
    }
}